import React from "react";

const PopularVehicles = () => {
  const vehicles = [
    {
      id: 1,
      image: "/images/fleet/Innova-Crysta.jpg",
      title: "Toyota Innova Crysta",
      category: "Premium SUV",
      seats: "6+1 Seats",
    },
    {
      id: 2,
      image: "/images/fleet/Maruti-Ertiga.jpg",
      title: "Maruti Ertiga",
      category: "SUV",
      seats: "6+1 Seats",
    },
    {
      id: 3,
      image: "/images/fleet/Kia-Carens.jpg",
      title: "Kia Carens",
      category: "Premium MUV",
      seats: "6+1 Seats",
    },
  ];

  return (
    <section
      className="feature-sec-1 p-0 py-3 bgrg "
      // style={{
      //   background:
      //     "linear-gradient(135deg,#f4f8ff 0%,#fff7f3 100%)",
      //   padding: "100px 0",
      // }}
    >
      <div className="container">
        {/* Heading */}
        <div className="row justify-content-center  ">
          <div className="col-xl-8 ">
            <div className="title-area text-center ">
              <div
                style={{
                  display: "inline-block",
                  background: "#FFF3EC",
                  color: "#F26722",
                  padding: "8px 20px",
                  borderRadius: "30px",
                  fontWeight: "700",
                  marginBottom: "15px",
                }}
              >
                🚖 Premium Fleet
              </div>

              <h2
                className="sec-title"
                style={{
                  color: "#0A2A66",
                  fontWeight: "800",
                }}
              >
                Our Popular Vehicles
              </h2>

              <p
                style={{
                  maxWidth: "700px",
                  margin: "0 auto",
                }}
              >
                Travel comfortably with our premium fleet of
                Innova Crysta, Ertiga and Kia Carens for
                airport transfers, corporate travel, local
                rides and outstation tours.
              </p>
            </div>
          </div>
        </div>

        {/* Vehicle Cards */}
        <div className="row g-4 justify-content-center p-0">
          {vehicles.map((vehicle) => (
            <div
              key={vehicle.id}
              className="col-xl-4 col-lg-4 col-md-6"
            >
              <div
                style={{
                  background: "#fff",
                  borderRadius: "25px",
                  overflow: "hidden",
                  boxShadow:
                    "0 15px 40px rgba(0,0,0,0.10)",
                  border: "2px solid #edf2f7",
                  transition: "0.4s ease",
                  height: "100%",
                }}
              >
                {/* Image Area */}
                <div
                  style={{
                    background:
                      "linear-gradient(135deg,#0A2A66 0%,#123D8C 100%)",
                    padding: "30px",
                    textAlign: "center",
                    position: "relative",
                  }}
                >
                  <span
                    style={{
                      position: "absolute",
                      top: "15px",
                      right: "15px",
                      background: "#F26722",
                      color: "#fff",
                      padding: "6px 15px",
                      borderRadius: "30px",
                      fontSize: "12px",
                      fontWeight: "700",
                    }}
                  >
                    Popular
                  </span>

                  <img
                    src={vehicle.image}
                    alt={vehicle.title}
                    style={{
                      width: "100%",
                      height: "240px",
                      objectFit: "contain",
                    }}
                  />
                </div>

                {/* Content */}
                <div style={{ padding: "30px" }}>
                  <h3
                    style={{
                      color: "#0A2A66",
                      fontWeight: "800",
                      fontSize: "30px",
                      marginBottom: "10px",
                    }}
                  >
                    {vehicle.title}
                    
                  </h3>

                  {/* <p
                    style={{
                      display: "inline-block",
                      background: "#FFF3EC",
                      color: "#F26722",
                      padding: "7px 16px",
                      borderRadius: "30px",
                      fontWeight: "700",
                      marginBottom: "25px",
                    }}
                  >
                    {vehicle.category}
                  </p> */}

                  {/* Features */}
                  <div className="row g-3 mb-4">
                    <div className="col-6">
                      <div
                        style={{
                          background: "#F8FAFC",
                          padding: "15px",
                          borderRadius: "12px",
                          textAlign: "center",
                          fontWeight: "600",
                        }}
                      >
                        👥 {vehicle.seats}
                      </div>
                    </div>

                    <div className="col-6">
                      <div
                        style={{
                          background: "#F8FAFC",
                          padding: "15px",
                          borderRadius: "12px",
                          textAlign: "center",
                          fontWeight: "600",
                        }}
                      >
                        ❄ AC
                      </div>
                    </div>
                  </div>

                  {/* Service Tags */}
                  <div
                    style={{
                      marginBottom: "25px",
                    }}
                  >
                    <span
                      style={{
                        background: "#eef4ff",
                        color: "#0A2A66",
                        padding: "6px 12px",
                        borderRadius: "20px",
                        marginRight: "8px",
                        fontSize: "13px",
                        fontWeight: "600",
                      }}
                    >
                      Airport
                    </span>

                    <span
                      style={{
                        background: "#eef4ff",
                        color: "#0A2A66",
                        padding: "6px 12px",
                        borderRadius: "20px",
                        marginRight: "8px",
                        fontSize: "13px",
                        fontWeight: "600",
                      }}
                    >
                      Outstation
                    </span>

                    <span
                      style={{
                        background: "#eef4ff",
                        color: "#0A2A66",
                        padding: "6px 12px",
                        borderRadius: "20px",
                        fontSize: "13px",
                        fontWeight: "600",
                      }}
                    >
                      Corporate
                    </span>
                  </div>

                  {/* Button */}
                  <a
                    href="/booking"
                    style={{
                      display: "block",
                      width: "100%",
                      textAlign: "center",
                      padding: "14px",
                      borderRadius: "10px",
                      textDecoration: "none",
                      color: "#fff",
                      fontWeight: "700",
                      background:
                        "linear-gradient(135deg,#F26722,#ff7f32)",
                    }}
                  >
                    Book Now
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
       
      </div>
    </section>
  );
};

export default PopularVehicles;